import { Decimal } from 'decimal.js';
export function getDivided(value, divisibility) {
    return new Decimal(value).div(Math.pow(10, divisibility));
}
export function roundAt(value, precision) {
    return new Decimal(value).mul(Math.pow(10, precision)).round().div(Math.pow(10, precision));
}



//////////////////
// WEBPACK FOOTER
// ./src/lib/numberUtils.ts
// module id = 60
// module chunks = 1